import isEmpty from '@automator/utilities/is-empty';

/**
 * Inserts parameter(s) to an URL.
 * If the parameter already exists it will update it
 *
 * @param {String}  url              The URL
 * @param {Object}  parameters       The parameters
 * @param {Object}  options          The options.
 * @param {Boolean} options.setAsURL True to set the URL as the current URL
 * @param {Boolean} options.refresh  True to refresh the page after setting the URL
 * @return {String}                  The URL with the parameters
 */
const addParametersToURL = ( url = '', parameters = {}, options = {} ) => {
	// If the URL is empty, use the site URL
	if ( isEmpty( url ) ) {
		url = window.location.href;
	}

	// Try to get an URL object
	try {
		url = new URL( url );
	} catch ( e ) {
		// If something goes wrong, just return the original URL
		return url;
	}

	// Get the current parameters in the URL
	let urlParameters = url.search.substr( 1 ).split( '&' );

	// Iterate the parameters
	for ( let [ key, value ] of Object.entries( parameters ) ) {
		key = encodeURI( key );
		value = encodeURI( value );

		let i = urlParameters.length;
		let x;

		while ( i-- ) {
			x = urlParameters[i].split( '=' );

			if ( x[0] == key ) {
				x[1] = value;
				urlParameters[i] = x.join( '=' );
				break;
			}
		}

		if ( i < 0 ) {
			urlParameters[urlParameters.length] = [ key, value ].join( '=' );
		}
	}

	// Remove empty parameters
	urlParameters = urlParameters.filter( ( parameter ) => {
		// Remove parameters without values
		const parameterParts = parameter.split( '=' );

		return ! ( isEmpty( parameter ) || isEmpty( parameterParts[1] ) );
	} );

	// Add parameters to the URL
	url.search = urlParameters.join( '&' );

	// Set default options
	options = Object.assign(
		{
			setAsURL: false,
			refresh: false,
		},
		options
	);

	// Check if we have to set it as the current URL
	if ( options.setAsURL ) {
		// Check if we have to reload
		if ( options.refresh ) {
			// This will reload the page, it's likely better to store this until finished
			window.location.href = url.href;
		} else {
			// Get title of the current page
			const pageTitle = document.title;

			// Push history and update URL
			window.history.pushState( {}, pageTitle, url.href );
		}
	}

	// Return URL
	return url.href;
};

export default addParametersToURL;
